import LazyDisp from "../class/lazydisp";
import TAGSORT, {taglist} from "../class/tagsort";

const [ w, d, l ] = [window, document, location];

const tabSort = () => {
  // カテゴリ・タグのタブ切り替え
  const $tabButton = $('.business-search__tabs li');
  const $tabContent = $('.business-search__tab');

  $tabButton.on('click', function( e ) {
    let index = $tabButton.index(this);
    let newHash = e.currentTarget.querySelector('a').hash

    w.history.pushState(null, null, newHash);

    //currentMenu
    $('.business-search__tab').currentMenu({ mode:0,default:999, url:l.pathname+l.search+l.hash });

    $tabContent.hide().eq(index).fadeIn();
    $tabButton.children('a').removeClass('current');
    $(this).children('a').addClass('current');

    return false;
  });

  if( l.hash.length ) {
    if( l.hash.match(/#tab/) ) {
      let tabname = l.hash.slice(4.1);
      tabname = tabname - 1;

      $tabContent.hide();
      $tabButton.children('a').removeClass('current');

      $tabContent.eq(tabname).fadeIn();
      $tabButton.eq(tabname).children('a').addClass('current');
    } else {
      $tabButton.eq(0).children('a').addClass('current');
      $tabContent.hide().eq(0).fadeIn();
    }
  } else {
    $tabButton.eq(0).children('a').addClass('current');
    $tabContent.hide().eq(0).fadeIn();
  }
}

const domReady = () => false;

const jqInit = () => {
  // テンプレート上書き
  const itemTemplate = `
    <div class="business-list-content is-list-12" :class="[ 'is-paged-' + paged ]">
    <div class="business-list-content__inner">
      <transition-group tag="ul" class="business-list-content__list" name="fade" mode="out-in">
        <li class="business-list-content__item" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
          <a :href="article.href" class="business-list-content__link">
            <figure class="business-list-content__thumb"><img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="business-list-content__thumb-img"></figure>
            <div class="business-list-content__body">
              <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
              <h5 class="title">{{ article.title }}</h5>
              <div class="tags" v-if="article.keywords != null">
                <span class="tag" v-for="keyword in article.keywords">#{{keyword}}</span>
              </div>
            </div><!-- /.business-list-content__body -->
          </a>
          <!-- /.business-list-content__link -->
        </li>
        <!-- /.business-list-content__item -->
      </transition-group>
      <!-- /.business-list-content__list -->
    </div>
    <!-- /.business-list-content__inner -->
  </div>
  <!-- /.business-list-content -->
  `;

  // taglistの拡張
  class taglist_custom extends taglist {
    constructor( opt, parent ) {
      super( opt, parent );
      this.template = `
        <div class="rwd002-taglist is-custom">
          <ul class="business-search__tabs" data-plugin="currentMenu">
            <li class="is-active">
              <a href="#tab1" class="btn current">
                <div class="inner">
                  <svg class="icon is-product" width="32" height="24"><use href="/assets/svg/sprite.symbol.svg#icon_industrial_machine"></use></svg>
                  <span>品目から探す</span>
                </div>
              </a>
              <!-- /.btn -->
            </li>
            <li>
              <a href="#tab2" class="btn">
                <div class="inner">
                  <svg class="icon is-type" width="25" height="15"><use href="/assets/svg/sprite.symbol.svg#icon_cardboard"></use></svg>
                  <span>業種から探す</span>
                </div>
              </a>
              <!-- /.btn -->
            </li>
          </ul>
          <div class="business-search__tabList">
            <catelist :cats="catlist" />
            <taglist :tags="taglist" :content="content" />
          </div>
          <!-- /.business-search__tabList -->
        </div>
        <!-- /.rwd002-taglist -->
      `;
      this.catComponent.template = `
        <div class="rwd002-taglist__cats business-search__tab">
          <a :href="cat.href+'#tab1'" class="rwd002-taglist__catBtn" v-for="cat in cats" :class="{ current : is_current(cat.id)}">{{ cat.name }}</a>
        </div>
      `;
      this.tagComponent.template = `
      <div class="rwd002-taglist__cats business-search__tab">
        <a :href="'/'+content+'/#tab2'" class="rwd002-taglist__catBtn">ALL</a>
        <a :href="'/'+content+'/?mode=list&tag='+tag.slug+'#tab2'" class="rwd002-taglist__catBtn" v-for="(tag, ind) in tags" :key="thisName+'-'+ind" :class="{current : is_current(tag.name)}" v-if="tag.name=='産業機器'||tag.name=='段ボール'||tag.name=='食品'">{{ tag.name }}</a>
      </div>
      `;
    }
  }

  const Tagsort = new TAGSORT({
    list: {
      itemTemplate,
    },
    taglist: {
      container: !d.body.classList.contains('is--list')? '.rwd002-pagination': false,
      minimumTagAmount : 4, // タグの最低表示数
      addAll: 'ALL',
      disp_list: 'head', // head / foot / both(true) / append / prepend
      disp_detail: 'foot', // head / foot / both(true) / append / prepend
    },
    related: {
      container: '.rwd002-pagination',
      disp_detail: true,
      itemTemplate: `
      <div class="business-related-content is-list-12" v-if="relatedArticles.length">
        <div class="business-related-content__inner">
          <h3 class="business-related-content__title">関連一覧</h3>
          <!-- /.business-related-content__title -->
          <ul class="business-related-content__list">
            <li class="business-related-content__item" v-for="( article, ind ) in relatedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
              <a :href="article.href" class="business-related-content__link">
                <figure class="business-related-content__thumb"><img :src="article.thumb" :alt="article.title" width="100%" loading="lazy" class="business-related-content__thumb-img"></figure>
                <div class="business-related-content__body">
                  <span class="cate" :class="'is-cat'+article.category.id" :data-href="article.category.href" v-if="article.category">{{ article.category.name }}</span>
                  <h5 class="title">{{ article.title }}</h5>
                  <div class="tags" v-if="article.keywords != null">
                  <span class="tag" v-for="keyword in article.keywords">#{{keyword}}</span>
                </div>
                </div><!-- /.business-related-content__body -->
              </a>
              <!-- /.business-related-content__link -->
            </li>
            <!-- /.business-related-content__item -->
          </ul>
          <!-- /.business-related-content__list -->
        </div>
        <!-- /.business-related-content__inner -->
      </div>
      <!-- /.business-related-content -->
      `,
      sortType: 'category', // or category
      amount: 3
    },
  });

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );

    // 詳細ページのタイトル下にタグを表示
    if( Tagsort.is_detail() ) {
      const d_detailHead = d.querySelector('.business-detail-head__body-inner');
      const detailTagHtml = ts => {
        const post_id = ts.getParam('article') || 1;
        const the_tags = ts.get_the_tags(post_id);
        return `
        <div class="business-detail-head__tags">${the_tags.map( t => `
          <a href="/${ts.opt.content}/?mode=list&tag=${encodeURI(t)}" class="btn btn-text">#${t}</a>
        `).join('')}</div>`;
      };
      if( d_detailHead ) d_detailHead.insertAdjacentHTML('beforeend', detailTagHtml(Tagsort) );
    }
  });
  
  // Renderがすべて完了後に実行(init後)
  d.addEventListener('tagsort.afterRender', e => {
    tabSort();
    $('.business-search__tabs, .business-search__tab').currentMenu({mode:0,default:999, url:l.pathname+l.search+l.hash});
  });

  // 拡張クラス定義後に実行すること
  Tagsort.render();
};

const onLoadHtml = () => {
  // LazyDisp開始
  new LazyDisp('[data-lazydisp]');

  setTimeout(() => $('.check-mainImg, .clean-mainImg, .factory-mainImg').addClass('is-active'), 700 );
};

export default function BUSINESS () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  $(() => jqInit());
  $(() => Promise.all([w.load['loadHtml']]).then( onLoadHtml ) );
}